import { useStore } from 'vuex'
import { Toast } from 'vant'
import { onMounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { submitPersonInfo, updatePersonInfo } from '@/api/person.js'
import qs from 'qs'

// 表单数据
export const useFormData = (hasInfo) => {
  const formData = reactive({
    cascaderValue: '',
  })

  const store = useStore()
  const route = useRoute()
  const router = useRouter()

  let showFormDataList = ref([])

  if (store.getters.getModuleInfo?.baseJson) {
    showFormDataList.value = JSON.parse(store.getters.getModuleInfo?.baseJson)
  } else {
    router.replace({
      path: '/',
      query: { ...route.query },
    })
  }

  // 根据返回的个人基本信息 初始化表单数据
  const initFormDate = () => {
    showFormDataList.value.forEach((item) => {
      formData[item.value] = ''
    })

    // 已经填过的 取出来值
    if (hasInfo) {
      const userSelection = store.getters.getUserSelection
      Object.keys(formData).forEach((key) => {
        formData[key] = userSelection[key]
      })
      formData.cascaderValue = userSelection.firstName
      formData.cascaderValue += userSelection.secondName
        ? `/${userSelection.secondName}`
        : ''
      formData.cascaderValue += userSelection.thirdName
        ? `/${userSelection.thirdName}`
        : ''
    }
  }

  onMounted(() => {
    initFormDate()
  })

  return {
    formData,
    showFormDataList,
  }
}

// 表单提交
export const useSubmit = (modifyFlag, hasInfo, cascaderData = {}) => {
  const store = useStore()
  const submitLoading = ref(false)

  const onSubmit = async (formData) => {
    
    const postData = JSON.parse(
      JSON.stringify({
        ...formData,
        ...cascaderData,
        questionActiveKey: store.getters.getShareInfo.questionActiveKey,
        token: store.getters.getToken,
      })
    )

    delete postData.cascaderValue

    let msg = '添加'
    let func = submitPersonInfo

    // 编辑状态
    if (modifyFlag.value && hasInfo) {
      func = updatePersonInfo
      msg = '修改'
      postData.id = store.getters.getUserSelection.id
    }

    submitLoading.value = true
    try {
      if (Object.getOwnPropertyNames(postData).length <= 3) {
        Toast('网络异常，请重试')
        router.go(-1)

        return
      }
      const res = await func(qs.stringify(postData))
      if (res.ok) {
        Toast(msg + '成功')

        store.commit('setUserSelection', {
          data: {
            ...formData,
            ...cascaderData,
          },
        })

        // 第一次进来成功 完成后跳到答题页面去
        if (!hasInfo) {
          handleJump2Index()
        } else {
          modifyFlag.value = false
        }
      } else {
        Toast(msg + '失败')
      }
    } catch (e) {
      console.log('e', e)
      submitLoading.value = false
    }

    submitLoading.value = false
  }

  const route = useRoute()
  const router = useRouter()
  // 第一次完成信息后跳到答题页
  const handleJump2Index = () => {
    // 如果oldPath是信息填报页面就跳回主页
    console.log(route.query.oldPath)
    if (route.query.oldPath == '/person/info' || !route.query.oldPath) {
      router.go(-1)

      return
    }

    const path = route.query.oldPath

    const query = route.query
    delete query.oldPath

    // 记录答题开始时间
    store.commit('setStartTime', {
      time: new Date(),
    })

    router.replace({
      path,
      query,
    })
  }

  return {
    onSubmit,
    submitLoading,
  }
}

// 表单校验
export const useValidator = () => {
  const rules = {
    name: [{ required: true, message: '*请填写姓名' }],
    mobile: [
      { required: true, message: '*请填写手机号' },
      {
        pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
        message: '*请输入正确的手机号',
      },
    ],
    birthday: [{ required: true, message: '*请填写生日' }],
    idNum: [
      { required: true, message: '*请填写身份证号码' },
      {
        pattern:
          /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        message: '*请输入正确的身份证号码',
      },
    ],
    age: [{ required: true, message: '*请填写年龄', type: 'number' }],
  }

  const formType = {
    name: 'text',
    mobile: 'tel',
    birthday: 'text',
    idNum: 'digit',
    age: 'digit',
  }

  return {
    rules,
    formType,
  }
}
